import { Component } from "react";
import PropTypes from "prop-types";
import NoResults from "../NotFound/NoResults";
import AutoRetry from "./AutoRetry";
import ResultsList from "./ResultsList";
import { parse } from "query-string";

export class ProductList extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.isLoadingPrevious) {
      this.previousBodyHeight = document.body.scrollHeight;

      return;
    }
    if (prevProps.isLoadingPrevious && !this.props.isLoadingPrevious) {
      const heightDifference =
        document.body.scrollHeight - this.previousBodyHeight;
      window.scrollTo(0, heightDifference);
    }
  }

  render() {
    const {
      pages,
      location,
      hasFacets,
      isErrorOfTypeServer,
      ...rest
    } = this.props;

    if (isErrorOfTypeServer) {
      return <AutoRetry />;
    }

    if (!pages.length && !hasFacets) {
      return <NoResults searchTerm={parse(location.search).q} />;
    }

    return <ResultsList pages={pages} {...rest} />;
  }
}

ProductList.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  isLoadingPrevious: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  hasFacets: PropTypes.bool.isRequired,
  isErrorOfTypeServer: PropTypes.bool.isRequired
};

ProductList.defaultProps = {
  isLoadingPrevious: false,
  isErrorOfTypeServer: false
};

ProductList.displayName = "ProductList";

export default ProductList;
